import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

/**
 * Gets spy profile by id
 */
export const getSpy = async ({ id, onlyPrimary = true }) =>
  callAuthorizedGraphQLEndpoint(
    `query ($id:ID! $onlyPrimary: Boolean ) {
      spy(spyId:$id){
        id
        firstName
        lastName
        status
        blockedReason
        referralCode
        businessNumber
        insuranceNumber
        documentsProvided
        email
        fixedPriceMissions
        flyerCount
        isVerified
        itemCount
        memberSince
        mobilePhone
        profilePicture
        withholdPay
        isTeamLeader
        restrictedMissionType
        role
        contractorType
        userWarning {
          count
        }
        paymentDetails {
          accountName
          accountNumber
          branchNumber
          bankAddress1
          bankAddress2
          bankCity
          bankPostCode
        }
        city {
          id
          name
          teamLeaderEnabled
          country{
            code
          }
        }
        formW9 {
          fileName
          fileSaveTime
        }
        signedLegalDocuments {
          totalCount
          edges {
            node {
              dateTime
              legalDocument {
                id
                url
                name
              }
            }
          }
        }
        

        documents(onlyPrimary: $onlyPrimary) {
          nodes {
              id
              url
              comment
              status
              createdAt
              updatedAt
              documentTypeId
              userId
              isPrimary
              rejectReason
              uploadedBy
              actorId
              uploader
              actor
          }
          count
        }
        paymentProviderData {
            userId
            initials
            gender
            birthdate
            nationality
            birthplace
            taxRebate
            comment
            rejectReason
            actorId
            status
            updatedAt
        }
        blockedInfo {
          created_at
          profile_user_id
          actioned_by_user_id
          user_who_updated
        }
        germanyContractData {
          address
          postalCode
          contractType
          startDate
          hoursPerWeek
          createdAt
          updatedAt
          status
          comment
          actorId
          reSignedAt
        }
      }
    }`,
    { id, onlyPrimary },
  )

export const getSpyActivity = async variables => {
  const query = `query ($spyId:ID! $first:Int $after:String) {
    spy(spyId:$spyId) {
      missions (first:$first after:$after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
             id
             status
             timeRangeStart
             timeOfDay
             user {
               firstName
               lastName
             }
             location{
               name
              }
             client{
               name
             }
             spyInformation{
              shift{
                id
              }
            }
          }
        }
      }    
    }
  }`
  const req = await callAuthorizedGraphQLEndpoint(query, variables)
  return req.json()
}
